import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js'
import quasarUserOptions from './quasar-user-options.js'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './router/routes'
import { roleGuard } from './router/roleGuard'
import baseService from './services/baseService'
import usersService from './services/usersService'

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!baseService.getToken()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  if (to.name === 'Login' && isAuthenticated) {
    return next('/dashboard')
  }

  const redirect = await roleGuard(to, () => usersService.getRole())
  if (redirect) {
    return next(redirect)
  }

  return next()
})

window.addEventListener('error', (event) => {
  if (event.message && event.message.includes("Cannot read properties of null (reading 'save')")) {
    event.stopImmediatePropagation()
    event.preventDefault()
  }
}, true)

const app = createApp(App)

app.config.errorHandler = (err) => {
  if (err && err.message && err.message.includes("Cannot read properties of null (reading 'save')")) {
    return
  }
  console.error(err)
}

app.use(Quasar, quasarUserOptions)
app.use(router)
app.mount('#app')
